import * as React from 'react';
import * as main from "../../main.module.scss";
import * as structure from "./style.module.scss";
export const Structure = () => {
  return (
    <section className={structure.structure}>
      <div className="container">
        <h2 className={main.title}>Структура обучения на курсе:</h2>
        <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/struk-01.png" className={structure.computer} alt=""/>
        <ul>
          <li><p>Освоение терминов на русском языке</p></li>
          <li><p>Изучение терминов на английском языке</p></li>
          <li><p>Введение лексики, активное использование с помощью тренажёра</p></li>
          <li><p>Распознавание и использование изученной лексики в разных контекстах</p></li>
          <li><p>Активное применение в работе</p></li>
        </ul>
        <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/struk-02.png" className={structure.person} alt=""/>
      </div>
    </section>
  );
};
